import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Box,
  Container
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { ExitToApp } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

const Header = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      toast.success('Deconectat cu succes');
      navigate('/');
    } catch (error) {
      toast.error('Eroare la deconectare');
    }
  };

  return (
    <AppBar position="static" elevation={2} sx={{ bgcolor: 'white', color: 'text.primary' }}>
      <Container maxWidth="lg">
        <Toolbar>
          <Box 
            component={Link} 
            to="/" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              textDecoration: 'none',
              mr: 3
            }}
          >
            <Box
              component="img"
              src="https://psde.md/wp-content/uploads/2025/03/logo.png"
              alt="PSDE Logo"
              sx={{
                height: 45,
                width: 'auto',
                mr: 2
              }}
            />
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'primary.main',
                fontWeight: 700
              }}
            >
              Petitii PSDE
            </Typography>
          </Box>
          
          <Box sx={{ flexGrow: 1 }} />
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              sx={{ color: 'text.primary', fontWeight: 600 }}
              component={Link} 
              to="/creaza-petitie"
            >
              Creează Petiție
            </Button>
            
            {user ? (
              <>
                <Button 
                  sx={{ color: 'text.primary' }}
                  component={Link} 
                  to="/admin"
                >
                  Dashboard Admin
                </Button>
                <Button 
                  sx={{ color: 'text.primary' }}
                  onClick={handleLogout}
                  startIcon={<ExitToApp />}
                >
                  Ieșire
                </Button>
              </>
            ) : (
              <Button 
                sx={{ color: 'text.primary' }}
                component={Link} 
                to="/admin/login"
              >
                Admin
              </Button>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
